const PUBLIC = process.env.PUBLIC_URL || "";
export const FRESHNESS_STAMP_LOGO_SRC = `${PUBLIC}/tabletop-stamp-logo.png`;

const STAMP_STYLES = `
  .tt-stamp-root {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .tt-stamp-label {
    width: 380px;
    background-color: #fffdf2;
    display: flex;
    flex-direction: column;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #1e4620;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    border: 1px solid #e6e0c8;
  }

  /* --- TOP SEAL: green frame with text on all 4 sides --- */
  .tt-seal-frame {
    display: grid;
    grid-template-columns: 30px 1fr 30px;
    background-color: #a3d3b2;
    padding: 6px 0;
  }

  .tt-seal-side {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .tt-seal-side span {
    font-weight: 900;
    font-size: 11px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #1a4d2e;
    white-space: nowrap;
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }

  .tt-seal-side--left span {
    transform: rotate(180deg);
  }

  .tt-seal-middle {
    min-width: 0;
    padding: 2px 0;
  }

  .tt-seal-border-h {
    font-weight: 900;
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #1a4d2e;
    margin: 4px 0;
    line-height: 1.1;
  }

  .tt-stamp-inner-card {
    background-color: #fffdf0;
    border: 4px dotted #a3d3b2;
    border-radius: 18px;
    padding: 18px 14px 16px;
    margin: 6px 0;
    position: relative;
  }

  .tt-stamp-order-id {
    position: absolute;
    top: 10px;
    left: 12px;
    font-size: 14px;
    font-weight: 800;
    color: #1a4d2e;
    line-height: 1.1;
    z-index: 2;
  }

  .tt-stamp-card-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    min-height: 56px;
    padding-right: 28px;
    padding-left: 28px;
  }

  .tt-stamp-brand-logo {
    width: 156px;
    max-width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    background: transparent;
    margin: 0 auto;
  }

  .tt-stamp-veg-icon {
    position: absolute;
    top: 2px;
    right: 0;
    width: 24px;
    height: 24px;
    border: 2px solid #0f8b44;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    flex-shrink: 0;
  }

  .tt-stamp-veg-icon::after {
    content: "";
    width: 12px;
    height: 12px;
    background-color: #0f8b44;
    border-radius: 50%;
    display: block;
  }

  .tt-stamp-meta-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 13px;
    gap: 6px;
  }

  .tt-stamp-meta-label {
    font-weight: bold;
    font-size: 16px;
    color: #e91e63;
    width: 38%;
    flex-shrink: 0;
    white-space: nowrap;
    line-height: 1.1;
  }

  .tt-stamp-meta-line {
    border-bottom: 1px dashed #c2cfb4;
    width: 62%;
    min-height: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding-bottom: 1px;
  }

  .tt-stamp-meta-value {
    font-weight: 800;
    font-size: 15px;
    color: #1a4d2e;
    line-height: 1.1;
    word-break: break-word;
    min-height: 16px;
  }

  .tt-stamp-meta-row--frosting .tt-stamp-meta-value {
    font-size: 12.5px;
  }

  .tt-stamp-freshness-promise {
    text-align: center;
    font-size: 11.5px;
    font-weight: bold;
    color: #72a281;
    line-height: 1.45;
    margin-top: 18px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  .tt-stamp-delivery-address {
    text-align: center;
    font-size: 11px;
    font-weight: 800;
    color: #1a4d2e;
    line-height: 1.35;
    margin-top: 10px;
    padding: 0 6px;
    text-transform: uppercase;
    letter-spacing: 0.25px;
    min-height: 14px;
  }

  /* --- BOTTOM: ingredients + brand logos --- */
  .tt-stamp-bottom {
    padding: 22px 20px 24px;
    background-color: #fffdf2;
  }

  .tt-stamp-section-title {
    font-size: 18px;
    font-weight: 800;
    color: #1a4d2e;
    margin-bottom: 12px;
    text-transform: uppercase;
  }

  .tt-stamp-ingredient-block {
    font-size: 12px;
    line-height: 1.55;
    margin-bottom: 11px;
    font-weight: bold;
  }

  .tt-stamp-ing-category {
    color: #1a4d2e;
    text-transform: uppercase;
  }

  .tt-stamp-ing-list {
    color: #e91e63;
    text-transform: uppercase;
  }

  .tt-stamp-pink-divider {
    width: 80px;
    height: 5px;
    background-color: #e91e63;
    margin: 18px auto 16px;
    border-radius: 2px;
  }

  .tt-stamp-logos-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px 10px;
    align-items: center;
    justify-items: center;
  }

  .tt-stamp-logo-item {
    width: 100%;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 11px;
    font-weight: bold;
    color: #555;
    line-height: 1.15;
  }
`;

function MetaRow({ label, value, frosting = false }) {
  return (
    <div className={`tt-stamp-meta-row${frosting ? " tt-stamp-meta-row--frosting" : ""}`}>
      <span className="tt-stamp-meta-label">{label}</span>
      <span className="tt-stamp-meta-line">
        <span className="tt-stamp-meta-value">{value || ""}</span>
      </span>
    </div>
  );
}

const BRAND_LOGOS = [
  { label: "VAN HOUTEN", style: { color: "#222", fontWeight: 800 } },
  { label: "Amul", style: { color: "#d12026", fontFamily: "Georgia, serif", fontSize: "13px" } },
  { label: "MALA'S", style: { color: "#0b1d66", fontWeight: 800 } },
  { label: "PATANJALI", style: { color: "#e31e24", fontWeight: 800 } },
  {
    label: "TRUST",
    style: { background: "#ffcc00", padding: "2px 6px", color: "#fff", fontWeight: 800 },
  },
  { label: "fortune", style: { color: "#d12026", fontWeight: 700 } },
  { label: "Tops", style: { color: "#d12026", fontWeight: 900 } },
  {
    label: "Rajdhani",
    style: { border: "1px solid #b32d2e", color: "#b32d2e", padding: "0 5px", fontWeight: 700 },
  },
  { label: "AASHIRVAAD", style: { color: "#e67e22", fontWeight: 800, fontSize: "10px" } },
];

export default function FreshnessStampView({ stamp }) {
  const data = stamp || {};

  return (
    <div className="tt-stamp-root">
      <style>{STAMP_STYLES}</style>
      <div className="tt-stamp-label" aria-label="Packaging label">
        <div className="tt-seal-frame">
          <div className="tt-seal-side tt-seal-side--left" aria-hidden="true">
            <span>Sealed For Freshness</span>
          </div>

          <div className="tt-seal-middle">
            <div className="tt-seal-border-h">Sealed For Freshness</div>

            <div className="tt-stamp-inner-card">
              {data.orderIdLabel ? (
                <div className="tt-stamp-order-id">{data.orderIdLabel}</div>
              ) : null}

              <div className="tt-stamp-card-header">
                <img
                  className="tt-stamp-brand-logo"
                  src={FRESHNESS_STAMP_LOGO_SRC}
                  alt="The Table Top"
                />
                <div className="tt-stamp-veg-icon" aria-hidden="true" />
              </div>

              <MetaRow label="Baked on -" value={data.bakedOn} />
              <MetaRow label="Baked At -" value={data.bakedAt} />
              <MetaRow label="Use by -" value={data.useBy} />
              <MetaRow label="Frosting time -" value={data.frostingTime} frosting />

              <div className="tt-stamp-freshness-promise">
                Baked only after you order.
                <br />
                Never stored.
              </div>

              <div className="tt-stamp-delivery-address">{data.deliveryAddress || ""}</div>
            </div>

            <div className="tt-seal-border-h">Sealed For Freshness</div>
          </div>

          <div className="tt-seal-side tt-seal-side--right" aria-hidden="true">
            <span>Sealed For Freshness</span>
          </div>
        </div>

        <div className="tt-stamp-bottom">
          <div className="tt-stamp-section-title">Ingredients -</div>

          <div className="tt-stamp-ingredient-block">
            <span className="tt-stamp-ing-category">Baking-</span>{" "}
            <span className="tt-stamp-ing-list">
              Maida, Caster Sugar, Fortune Rice Bran Oil, Full Cream Milk, Baking Powder
            </span>
          </div>

          <div className="tt-stamp-ingredient-block">
            <span className="tt-stamp-ing-category">Frosting -</span>{" "}
            <span className="tt-stamp-ing-list">
              Fresh Fruit Chunks and Compote, Fresh Cream, Chocolate (30% Cocoa), Whipped Cream,
              Cream Cheese
            </span>
          </div>

          <div className="tt-stamp-pink-divider" aria-hidden="true" />

          <div className="tt-stamp-logos-grid">
            {BRAND_LOGOS.map((item) => (
              <div key={item.label} className="tt-stamp-logo-item" style={item.style}>
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
